// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionFlipAndWin_root__1U7Yw","partners":"SectionFlipAndWin_partners__G2M-S","carouselAnimationForward":"SectionFlipAndWin_carouselAnimationForward__7QSpk"};